import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4 p-6" }
const _hoisted_2 = { class: "flex items-center justify-between mb-4" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_7 = { class: "text-sm text-gray-600 dark:text-gray-400 mb-2" }
const _hoisted_8 = { class: "w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2" }
const _hoisted_9 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_10 = { class: "flex gap-3 justify-center" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "mt-4 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
}
const _hoisted_13 = { class: "flex items-center justify-between text-sm" }
const _hoisted_14 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_15 = { class: "flex items-center justify-between text-sm mt-1" }
const _hoisted_16 = { class: "font-medium text-gray-900 dark:text-white" }

import { ref, onMounted, onUnmounted } from 'vue';
import GoogleAd from './GoogleAd.vue';

import { watch } from 'vue';
interface Props {
  isVisible: boolean;
  downloadInfo?: {
    name: string;
    size: string;
  };
  countdownDuration?: number;
}

interface Emits {
  (e: 'download'): void;
  (e: 'close'): void;
  (e: 'skip'): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InterstitialAdModal',
  props: {
    isVisible: { type: Boolean },
    downloadInfo: {},
    countdownDuration: { default: 5 }
  },
  emits: ["download", "close", "skip"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// State
const countdown = ref(0);
const initialCountdown = ref(0);
let countdownInterval: number | null = null;

// Methods
const startCountdown = () => {
  countdown.value = props.countdownDuration;
  initialCountdown.value = props.countdownDuration;
  
  countdownInterval = setInterval(() => {
    countdown.value--;
    
    if (countdown.value <= 0) {
      clearInterval(countdownInterval!);
      countdownInterval = null;
    }
  }, 1000);
};

const handleDownload = () => {
  emit('download');
  handleClose();
};

const handleSkip = () => {
  if (countdown.value > 3) return; // Prevent skipping too early
  
  emit('skip');
  handleClose();
};

const handleBackdropClick = () => {
  if (countdown.value <= 3) {
    handleSkip();
  }
};

const handleClose = () => {
  if (countdownInterval) {
    clearInterval(countdownInterval);
    countdownInterval = null;
  }
  countdown.value = 0;
  emit('close');
};

// Lifecycle
onMounted(() => {
  if (props.isVisible) {
    startCountdown();
  }
});

onUnmounted(() => {
  if (countdownInterval) {
    clearInterval(countdownInterval);
  }
});

// Watch for visibility changes
watch(() => props.isVisible, (newValue) => {
  if (newValue) {
    startCountdown();
  } else {
    handleClose();
  }
});

return (_ctx: any,_cache: any) => {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75",
        onClick: _withModifiers(handleBackdropClick, ["self"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 dark:text-white" }, " Preparing Your Download ", -1)),
            _createElementVNode("button", {
              onClick: handleSkip,
              class: "text-gray-400 hover:text-gray-600 dark:hover:text-gray-300",
              disabled: countdown.value > 0
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("svg", {
                class: "w-6 h-6",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ]), 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(GoogleAd, {
              "ad-type": "square",
              "show-label": false,
              "min-content-height": 0,
              class: "min-h-[200px] flex items-center justify-center bg-gray-100 dark:bg-gray-700 rounded-lg"
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            (countdown.value > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, " Your download will start in " + _toDisplayString(countdown.value) + " seconds ", 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: "bg-blue-600 h-2 rounded-full transition-all duration-1000",
                      style: _normalizeStyle({ width: `${((initialCountdown.value - countdown.value) / initialCountdown.value) * 100}%` })
                    }, null, 4)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[2] || (_cache[2] = [
                  _createElementVNode("p", { class: "text-sm text-green-600 dark:text-green-400 mb-2" }, " Ready to download! ", -1)
                ]))),
            _createElementVNode("div", _hoisted_10, [
              (countdown.value === 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: handleDownload,
                    class: "px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                  }, " Download Now "))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onClick: handleSkip,
                disabled: countdown.value > 3,
                class: _normalizeClass([
              'px-4 py-2 rounded-lg transition-colors text-sm',
              countdown.value > 3
                ? 'bg-gray-200 text-gray-400 cursor-not-allowed dark:bg-gray-700 dark:text-gray-500'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600'
            ])
              }, _toDisplayString(countdown.value > 3 ? `Skip (${countdown.value - 3}s)` : 'Skip Ad'), 11, _hoisted_11)
            ])
          ]),
          (_ctx.downloadInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-gray-600 dark:text-gray-400" }, "File:", -1)),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.downloadInfo.name), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-gray-600 dark:text-gray-400" }, "Size:", -1)),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.downloadInfo.size), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})